import { FormTemplate } from '../models/FormTemplate';
import { User } from '../models/User';
import { isAddressComplete } from './isAddressComplete';

export const reservedDataSourceKeys = [
  'birthDate',
  'state',
  'address',
  'biologicalSex',
  'phoneNumber',
  'phoneNumberCode',
  'notifyForMessages',
  'notifyForStudy'
];

/**
 * Check that all required fields have been completed
 * @param formTemplate
 * @param formData
 * @returns
 */
export function hasCompletedFormTemplateFields(
  formTemplate: FormTemplate,
  formData: any,
  user?: User | null
) {
  for (const stateNode of formTemplate.config?.states || []) {
    const elements = stateNode.meta?.elements || [];
    for (const element of elements) {
      if (!element.required) continue;

      if (element.type === 'Address' || element.dataSource === 'address') {
        if (
          !isAddressComplete(formData?.address) &&
          !isAddressComplete(user?.address)
        ) {
          return false;
        }
        continue;
      }

      if (
        element.dataSource &&
        (typeof formData[element.dataSource] === 'undefined' ||
          formData[element.dataSource] === null) &&
        (reservedDataSourceKeys.includes(element.dataSource)
          ? !user?.[element.dataSource as keyof User]
          : false)
      ) {
        return false;
      }
    }
  }
  return true;
}
